/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type PrivacyPolicyPage_viewer$ref = any;
export type queries_PrivacyPolicyPage_QueryVariables = {};
export type queries_PrivacyPolicyPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": PrivacyPolicyPage_viewer$ref;
    }) | null;
};
export type queries_PrivacyPolicyPage_Query = {
    readonly response: queries_PrivacyPolicyPage_QueryResponse;
    readonly variables: queries_PrivacyPolicyPage_QueryVariables;
};



/*
query queries_PrivacyPolicyPage_Query {
  viewer {
    id
    ...PrivacyPolicyPage_viewer
  }
}

fragment PrivacyPolicyPage_viewer on Viewer {
  id
  user {
    id
    role
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_PrivacyPolicyPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "PrivacyPolicyPage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_PrivacyPolicyPage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_PrivacyPolicyPage_Query",
            "id": null,
            "text": "query queries_PrivacyPolicyPage_Query {\n  viewer {\n    id\n    ...PrivacyPolicyPage_viewer\n  }\n}\n\nfragment PrivacyPolicyPage_viewer on Viewer {\n  id\n  user {\n    id\n    role\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '6e247427eb9e5cdca67448b6786e5e29';
export default node;
